import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FromToOffsetControlComponent } from './from-to-offset-control.component';
import { MatIconModule } from '@angular/material/icon';
import { ReactiveFormsModule } from '@angular/forms';
import { MatSliderModule } from '@angular/material/slider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ActionButtonsModule } from '@fleet/ui';

import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [FromToOffsetControlComponent],
  imports: [
    CommonModule,
    MatIconModule,
    ReactiveFormsModule,
    MatSliderModule,
    MatFormFieldModule,
    MatIconModule,
    ActionButtonsModule,
  ],
  exports: [FromToOffsetControlComponent],
})
export class FromToOffsetControlModule {}
